import '@/assets/sass/index.scss'
import '@/instance/hooks'
import 'normalize.css'
import 'vue-material/dist/vue-material.min.css'
import 'vue2-animate/dist/vue2-animate.css'
import InstanceFactory from '@/instance/InstanceFactory'
import options from '@/instance/options'
import plugins from '@/instance/plugins'

InstanceFactory.create(plugins, options)
